import type { SVGProps } from "react";
export default function SvgCallAnalysisAppNoShadow(props: SVGProps<SVGSVGElement>) {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width="1em"
			height="1em"
			fill="none"
			viewBox="0 0 112 112"
			{...props}
		>
			<foreignObject width={107.572} height={107.747} x={-5.99854} y={-6}>
				<div
					style={{
						backdropFilter: "blur(9px)",
						clipPath: "url(#bgblur_0_1110_630_clip_path)",
						height: "100%",
						width: "100%",
					}}
				/>
			</foreignObject>
			<g data-figma-bg-blur-radius={18} filter="url(#filter0_i_1110_630)">
				<path
					fill="url(#paint0_linear_1110_630)"
					fillOpacity={0.6}
					d="m12.157 80.078 6.337-18.216c-2.328-4.645-3.67-9.87-3.67-15.42C14.825 27.417 30.216 12 49.2 12s34.375 15.418 34.375 34.441c0 19.02-15.389 34.441-34.375 34.441-5.52 0-10.717-1.336-15.337-3.65L15.66 83.588c-2.172.759-4.258-1.331-3.501-3.508z"
				/>
				<path
					stroke="url(#paint1_linear_1110_630)"
					d="M49.199 12.5c18.706 0 33.875 15.194 33.875 33.941 0 18.746-15.166 33.942-33.875 33.942-5.439 0-10.56-1.317-15.114-3.599l-.188-.095-.2.07-18.201 6.357c-1.776.62-3.484-1.088-2.864-2.872l.103-.295-.003-.003 6.234-17.92.07-.199-.095-.19c-2.295-4.578-3.616-9.726-3.616-15.196 0-18.747 15.167-33.94 33.874-33.941Z"
				/>
			</g>
			<foreignObject width={93.2046} height={93.3408} x={24.7935} y={24.6592}>
				<div
					style={{
						backdropFilter: "blur(9px)",
						clipPath: "url(#bgblur_1_1110_630_clip_path)",
						height: "100%",
						width: "100%",
					}}
				/>
			</foreignObject>
			<g data-figma-bg-blur-radius={18} filter="url(#filter2_i_1110_630)">
				<path
					fill="white"
					fillOpacity={0.01}
					d="M99.87 97.066 94.804 82.51a27.4 27.4 0 0 0 2.933-12.324c0-15.202-12.3-27.526-27.472-27.526S42.793 54.984 42.793 70.185c0 15.2 12.3 27.525 27.473 27.525 4.41 0 8.564-1.068 12.26-2.918l14.546 5.082c1.736.605 3.404-1.065 2.8-2.805z"
				/>
				<path
					stroke="url(#paint2_linear_1110_630)"
					strokeOpacity={0.5}
					d="M70.265 43.16c14.895 0 26.973 12.099 26.973 27.025 0 4.353-1.052 8.454-2.88 12.1l-.095.189.07.199 5.064 14.558.016.043c.414 1.29-.772 2.51-2.051 2.166l-.125-.039-14.547-5.08-.2-.07-.189.095a26.8 26.8 0 0 1-12.036 2.864c-14.894 0-26.971-12.1-26.971-27.025 0-14.926 12.077-27.026 26.971-27.026Z"
				/>
			</g>
			<path
				fill="#FAFF00"
				d="M56.295 74.086c2.13 0 3.858-1.73 3.858-3.865a3.86 3.86 0 0 0-3.858-3.865 3.86 3.86 0 0 0-3.858 3.865 3.86 3.86 0 0 0 3.858 3.865"
			/>
			<path
				fill="#FAFF00"
				d="M74.19 70.15a3.86 3.86 0 0 1-3.858 3.866 3.864 3.864 0 0 1-3.858-3.865 3.864 3.864 0 0 1 3.858-3.866 3.864 3.864 0 0 1 3.858 3.866"
			/>
			<path
				fill="#FAFF00"
				d="M84.236 74.086c2.131 0 3.858-1.73 3.858-3.865a3.86 3.86 0 0 0-3.858-3.865 3.86 3.86 0 0 0-3.858 3.865 3.86 3.86 0 0 0 3.858 3.865"
			/>
			<defs>
				<linearGradient
					id="paint0_linear_1110_630"
					x1={47.97}
					x2={47.97}
					y1={12}
					y2={83.7467}
					gradientUnits="userSpaceOnUse"
				>
					<stop stopColor="#F5FCFF" />
					<stop offset={1} stopColor="#BBD3DD" />
				</linearGradient>
				<linearGradient
					id="paint1_linear_1110_630"
					x1={47.7875}
					x2={21.2537}
					y1={12.7857}
					y2={71.6084}
					gradientUnits="userSpaceOnUse"
				>
					<stop stopColor="white" />
					<stop offset={0.519231} stopColor="#A6BEC4" />
					<stop offset={1} stopColor="white" />
				</linearGradient>
				<linearGradient
					id="paint2_linear_1110_630"
					x1={71.3958}
					x2={71.3958}
					y1={42.6592}
					y2={100}
					gradientUnits="userSpaceOnUse"
				>
					<stop stopColor="#F5FCFF" />
					<stop offset={0.509653} stopColor="#B1D2DB" />
					<stop offset={1} stopColor="#F5FCFF" />
				</linearGradient>
				<clipPath id="bgblur_0_1110_630_clip_path" transform="translate(5.999 6)">
					<path d="m12.157 80.078 6.337-18.216c-2.328-4.645-3.67-9.87-3.67-15.42C14.825 27.417 30.216 12 49.2 12s34.375 15.418 34.375 34.441c0 19.02-15.389 34.441-34.375 34.441-5.52 0-10.717-1.336-15.337-3.65L15.66 83.588c-2.172.759-4.258-1.331-3.501-3.508z" />
				</clipPath>
				<clipPath id="bgblur_1_1110_630_clip_path" transform="translate(-24.794 -24.66)">
					<path d="M99.87 97.066 94.804 82.51a27.4 27.4 0 0 0 2.933-12.324c0-15.202-12.3-27.526-27.472-27.526S42.793 54.984 42.793 70.185c0 15.2 12.3 27.525 27.473 27.525 4.41 0 8.564-1.068 12.26-2.918l14.546 5.082c1.736.605 3.404-1.065 2.8-2.805z" />
				</clipPath>
				<filter
					id="filter0_i_1110_630"
					width={107.572}
					height={107.747}
					x={-5.99854}
					y={-6}
					colorInterpolationFilters="sRGB"
					filterUnits="userSpaceOnUse"
				>
					<feFlood floodOpacity={0} result="BackgroundImageFix" />
					<feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
					<feColorMatrix
						in="SourceAlpha"
						result="hardAlpha"
						values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
					/>
					<feOffset dy={-1} />
					<feGaussianBlur stdDeviation={2.5} />
					<feComposite in2="hardAlpha" k2={-1} k3={1} operator="arithmetic" />
					<feColorMatrix values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0" />
					<feBlend in2="shape" result="effect1_innerShadow_1110_630" />
				</filter>
				<filter
					id="filter2_i_1110_630"
					width={93.2046}
					height={93.3408}
					x={24.7935}
					y={24.6592}
					colorInterpolationFilters="sRGB"
					filterUnits="userSpaceOnUse"
				>
					<feFlood floodOpacity={0} result="BackgroundImageFix" />
					<feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
					<feColorMatrix
						in="SourceAlpha"
						result="hardAlpha"
						values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
					/>
					<feOffset dy={-1} />
					<feGaussianBlur stdDeviation={2.5} />
					<feComposite in2="hardAlpha" k2={-1} k3={1} operator="arithmetic" />
					<feColorMatrix values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0" />
					<feBlend in2="shape" result="effect1_innerShadow_1110_630" />
				</filter>
			</defs>
		</svg>
	);
}
